import React from 'react';
import classNames from 'classnames';
import './Stepper.scss';

export interface IStepperStep {
  title: string;
  hasError?: boolean;
  onClick(idx: number): void;
}

interface IStepperProps {
  progress: number;
  steps: IStepperStep[];
  className?: string;
}

const Stepper: React.FC<IStepperProps> = ({ progress, steps }) => {
  return (
    <div className="stepper">
      <div className="stepper__container">
        <div className="stepper__content">
          <div className="stepper__steps">
            {steps.map((step, index) => (
              <div key={index} className="stepper__step-wrapper">
                <div
                  className="stepper__step"
                  onClick={() => step.onClick(index)}
                  role="button"
                  tabIndex={0}
                >
                  <div
                    className={classNames('stepper__step-circle', {
                      'stepper__step-circle--active': progress >= index,
                      'stepper__step-circle--completed': progress > index,
                      'stepper__step-circle--error':
                        step.hasError && progress >= index
                    })}
                  >
                    {progress > index ? (
                      <span className="stepper__step-check">✓</span>
                    ) : (
                      <span className="stepper__step-number">{index + 1}</span>
                    )}
                  </div>
                  <div
                    className={classNames('stepper__step-title', {
                      'stepper__step-title--active': progress >= index,
                      'stepper__step-title--error':
                        step.hasError && progress >= index
                    })}
                  >
                    {step.title}
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={classNames('stepper__step-line', {
                      'stepper__step-line--active': progress > index,
                      'stepper__step-line--error':
                        step.hasError && progress > index
                    })}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
